import type { CalculatorMode } from "../../types/tax";

interface ResultsToggleProps {
  mode: CalculatorMode;
  onModeChange: (mode: CalculatorMode) => void;
  hasReverseResult: boolean;
  hasForwardResult: boolean;
}

export default function ResultsToggle({ 
  mode, 
  onModeChange, 
  hasReverseResult, 
  hasForwardResult 
}: ResultsToggleProps) {
  // Only show toggle if both have results
  if (!hasReverseResult || !hasForwardResult) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md p-4">
      <div className="flex items-center justify-center gap-2">
        <span className="text-sm text-gray-600 dark:text-slate-400">Viewing:</span>
        <div className="flex bg-gray-100 dark:bg-slate-700 rounded-lg p-1">
          <button
            type="button"
            onClick={() => onModeChange('reverse')}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              mode === 'reverse'
                ? 'bg-white dark:bg-slate-600 text-sa-green shadow-sm'
                : 'text-gray-600 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-200'
            }`}
          >
            Net → Gross Result
          </button>
          <button
            type="button"
            onClick={() => onModeChange('forward')}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              mode === 'forward'
                ? 'bg-white dark:bg-slate-600 text-sa-green shadow-sm'
                : 'text-gray-600 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-200'
            }`}
          >
            Gross → Net Result
          </button>
        </div>
      </div>
    </div>
  );
}
